import { useState, useEffect } from 'react'
import { fetchSearchOptions } from '../helpers/fetchSearchOptions';

export const useFetchSearch = ( geoserverUrl, layerName, load ) => {

    const [searchOptions, setSearchOptions] = useState('');
    
    useEffect( () => {
        fetchSearchOptions( geoserverUrl, layerName )
            .then( data => {                
                setSearchOptions(data);
                load(false)
            })
    }, [layerName])
    return searchOptions;
}